import React from 'react';
import Skeleton from './Skeleton';

// Small label/value tile used for stat strips and detail info grids.
// loading: подпись известна заранее, поэтому остаётся настоящей, а на месте
// значения — плашка в строку 22px, чтобы плитка не меняла высоту.
const InfoCard = ({ label, value, hint, accent, loading = false }) => (
  <div className="flex-1 min-w-0 bg-surface border border-line rounded-lg px-3 py-2.5">
    <div className="flex flex-col gap-0.5">
      <span className="text-[10px] leading-[12px] uppercase tracking-[0.4px] text-ink-muted truncate">
        {label}
      </span>
      {loading ? (
        <div className="h-[22px] flex items-center">
          <Skeleton width={56} height={16} />
        </div>
      ) : (
        <span className={`text-[18px] leading-[22px] font-semibold truncate ${accent || 'text-ink'}`}>
          {value}
        </span>
      )}
      {!loading && hint && <span className="text-[10px] leading-[12px] text-ink-muted truncate">{hint}</span>}
    </div>
  </div>
);

export default InfoCard;
